import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        overflowX: 'hidden',
        '&:first-child': {
          marginTop: 76,
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,

          '&:first-child': {
            marginTop: 120,
          },
        },
      },
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      detailsBox: {
        borderRadius: 5,
        background: theme.palette.secondary.light,
        boxSizing: 'border-box',
        boxShadow: '0px 3px 6px rgba(0,0,0,.66)',
        padding: '43px 28px 40px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          display: 'flex',
          justifyContent: 'space-between',
          background: 'transparent',
          boxShadow: 'none',
          padding: 0,
        },
      },
      detailBox: {
        display: 'flex',
        width: '100%',
        marginBottom: 30,
        '&:last-child': {
          marginBottom: 0,
        },
        [theme.breakpoints.up('sm')]: {
          width: 'calc(33% - 8px)',
          background: theme.palette.secondary.light,
          boxSizing: 'border-box',
          borderRadius: 5,
          padding: 20,
          boxShadow: '0px 3px 6px rgba(0,0,0,.66)',
          display: 'block',
          marginBottom: 0,
        },
        [theme.breakpoints.up('md')]: {
          width: 'calc(33% - 8px)',
          background: theme.palette.secondary.light,
          boxSizing: 'border-box',
          borderRadius: 5,
          padding: 30,
          boxShadow: '0px 3px 6px rgba(0,0,0,.66)',
          marginBottom: 0,
        },
      },
      detailBoxContent: {
        marginTop: 0,
        [theme.breakpoints.up('sm')]: {
          marginTop: 37,
        },
      },
      detailBoxImage: {
        display: 'flex',
        alignItems: 'center',
        width: 50,
        height: 50,
        marginRight: 23,
        [theme.breakpoints.up('sm')]: {
          width: 72,
          height: 72,
          marginRight: 0,
        },
        '& img': {
          maxWidth: '100%',
          maxHeight: '100%',
        },
      },
      detailBoxTitle: {
        marginBottom: 8,
        fontSize: 18,
        lineHeight: '22px',
        [theme.breakpoints.up('sm')]: {
          marginBottom: 11,
          fontSize: 25,
          lineHeight: '31px',
        },
      },
      detailBoxDescription: {
        fontSize: 16,
        lineHeight: '1.5',
        color: colorsPalette.gray,
        wordBreak: 'break-word',
        '& p, & strong': {
          margin: 0,
          fontSize: 'inherit',
          lineHeight: 'inherit',
        },
        [theme.breakpoints.up('sm')]: {
          fontSize: 18,
          lineHeight: '1.5',
          color: colorsPalette.gray,
          '& p, & strong': {
            margin: 0,
            fontSize: 'inherit',
            lineHeight: 'inherit',
          },
        },
      },
    }),
  );
export default useStyles;
